<template>
  <chip :get-status="getStatus" />
</template>

<script>
import Chip from './components/Chip.vue';

export default {
  name: 'SgvInjectionSituationColumn',
  components: { Chip },
  props: {
    value: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    status: {
      pendente: {
        color: '#FAF6EA',
        textColor: 'warning',
        label: 'Pendente',
      },
      efetivado: {
        color: '#EAFAF5',
        textColor: 'success',
        label: 'efetivado',
      },
      error: {
        color: '#FAEAEB',
        textColor: 'error',
        label: 'error',
      },
    },
  }),
  computed: {
    getStatus() {
      return this.status[this.value.toLowerCase()];
    },
  },
};
</script>
